import { withStyles } from '@material-ui/core';
import { getTimeString, isDelayStop } from '../../../Utils';
import appConstants from '../../../../../../../appConstants';

const styles = (theme) => ({
  proStatus: {
    fontWeight: 500,
    paddingTop: 4,
    fontSize: theme.dispatchCardTextFontSize,
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: 8
  },
  delayedClass: { color: theme.error },
  status: { paddingRight: 4 }
});
const PendingStopStatus = ({ classes, stopData }) => {
  const isDelayedStop = isDelayStop(stopData);
  return (
    <div className={classes.proStatus}>
      <div>{`${stopData.bills || 0} Bills`}</div>
      <div className={isDelayedStop ? classes.delayedClass : ''}>
        {isDelayedStop ? (
          <span className={classes.status}>{`(${appConstants.STOP_STATUS.DELAYED})`}</span>
        ) : (
          ''
        )}
        {`ETA ${getTimeString(stopData.plannedArrivalTime)}`}
      </div>
    </div>
  );
};

export default withStyles(styles)(PendingStopStatus);
